<!-- Header -->
<div *ngIf="container" class="container-header">
  <div class="container-info" test-id="container-data-info" #popoverContent>
    <span class="container-label" test-id="container-name-label">
      {{ container.label }}
    </span>
    <span *ngIf="sessionTimestamp" class="session-timestamp" test-id="session-timestamp">
      {{ sessionTimestamp }}
    </span>
  </div>
  <fw-popover [trigger]="popoverContent" position="below" action="mouseenter">
    <div class="container-info-popover padding-15">
      <strong>{{ container.label }}</strong>
      <span *ngIf="sessionTimestamp" class="bombay-grey">{{ sessionTimestamp }}</span>
    </div>
  </fw-popover>
  <div class="container-actions" fwMenuCloseTriggers>
    <fw-button
      *ngIf="tasksRefactorEnabled && containerType === ContainerType.Session && permissions.tasksModify"
      rightIcon="chevron-down"
      size="small"
      test-id="create-task-button"
      variant="outline"
      [cdkMenuTriggerFor]="createTaskTmpl"
    >
      Create Task
    </fw-button>
    <ng-template #createTaskTmpl>
        <fw-menu-container width="175px" offset="6px" shadow="large">
          <fw-menu>
            <fw-menu-item title="Reader" (click)="createReaderTask()"></fw-menu-item>
          </fw-menu>
        </fw-menu-container>
    </ng-template>
    <fw-button *ngIf="containerType === ContainerType.Session && permissions.runGear"
      size="small"
      test-id="run-gear"
      variant="outline"
      (click)="runGear()"
    >
      {{ 'sessionDetail.actions.runGear' | translate }}
    </fw-button>
    <fw-button
      *ngIf="containerType === ContainerType.Session && permissions.viewFiles && dicomViewer.ohifEnabled && dicomViewer.acquisitionIds.length > 0"
      size="small"
      test-id="view-dicom-study"
      (click)="viewDicomStudy()"
    >
      Launch in Viewer
    </fw-button>

    <fw-icon-button color="primary" icon="menu-vertical" size="small" [cdkMenuTriggerFor]="menu"></fw-icon-button>
    <ng-template #menu>
      <fw-menu-container>
        <fw-menu [multiSelect]="undefined">
          <fw-menu-item
            *ngIf="containerType === ContainerType.Session && permissions.createContainer && permissions.uploadFiles"
            [title]="'sessionDetail.actions.createAcquisition' | translate"
            (click)="createAcquisition()"
            test-id="create-new-acquisition"
          ></fw-menu-item>
          <fw-menu-item *ngIf="permissions.downloadFiles"
            [title]="containerType === ContainerType.Session
            ? ('sessionDetail.actions.downloadSessionFiles' | translate)
            : ('sessionDetail.actions.downloadSubjectFiles' | translate)"
            (click)="downloadFiles()"
            test-id="download-files"
          ></fw-menu-item>

          <ng-container *ngIf="permissions.viewContainerMetadata">
            <fw-menu-item *ngFor="let app of viewerApps"
              [attr.test-id]="'viewer-app-' + app.name"
              [title]="'common.actions.launchIn' | translate | interpolate:app.name"
              (click)="viewContainer(app)"
            ></fw-menu-item>
          </ng-container>

          <ng-container *ngIf="containerType === ContainerType.Session && projectBids">
            <fw-menu-item *ngVar="bidsView$ | async as bidsView"
              [multiSelect]="true"
              [selected]="bidsView"
              [showCheckbox]="true"
              [title]="'sessionDetail.actions.bidsView' | translate"
              (click)="$any($event).stopPropagation?.(); toggleBidsView(!bidsView)"
              test-id="toggle-bids-view"
            ></fw-menu-item>
          </ng-container>

          <fw-menu-item *ngVar="state.originalTimezone$ | async as originalTimezone"
            [multiSelect]="true"
            [selected]="originalTimezone"
            [showCheckbox]="true"
            [title]="'sessionDetail.actions.originalTimezone' | translate"
            (click)="$any($event).stopPropagation?.(); toggleOriginalTimezones(!originalTimezone)"
            test-id="display-original-timezone"
          ></fw-menu-item>

          <fw-tooltip position="left" [title]="'sessionDetail.actions.runGearRulesTooltip' | translate">
            <fw-menu-item *ngVar="state.runGearRulesOnMove$ | async as runGearRulesOnMove"
              [multiSelect]="true"
              [selected]="runGearRulesOnMove"
              [showCheckbox]="true"
              [title]="'sessionDetail.actions.runGearRules' | translate"
              (click)="$any($event).stopPropagation?.(); toggleRunGearRules(!runGearRulesOnMove)"
              test-id="rerun-gear-rules"
            ></fw-menu-item>
          </fw-tooltip>

          <ng-container *ngIf="permissions.deleteContainer">
            <fw-menu-separator></fw-menu-separator>
            <fw-menu-item [title]="containerType === ContainerType.Session
                ? ('sessionDetail.actions.deleteSession' | translate)
                : ('sessionDetail.actions.deleteSubject' | translate)"
              (click)="delete()"
              test-id="delete-container"
            ></fw-menu-item>
          </ng-container>

        </fw-menu>
      </fw-menu-container>
    </ng-template>
  </div>
</div>

<!-- Tabs -->
<mat-tab-group *ngIf="container; else loadingState" [selectedIndex]="activeTabIndex$ | async" (selectedTabChange)="onTabChange($event)"
  mat-stretch-tabs="false" animationDuration="0ms" class="tabs-white tabs-compact">

  <!-- Acquisitions -->
  <mat-tab active [attr.tab-id]="'data'" *ngIf="containerType === 'session'"
    [label]="'sessionDetail.tabs.acquisitions' | translate">
    <!-- Not lazy, to detect DICOM files and show View DICOM Study button -->
    <session-data [session]="session" [project]="project" [collectionId]="collectionId$.value" class="tab-content">
    </session-data>
  </mat-tab>

  <!-- Session -->
  <mat-tab [attr.tab-id]="'annotation'" *ngIf="containerType === 'session'"
    [label]="'sessionDetail.tabs.session' | translate">
    <ng-template matTabContent>
      <div class="tab-content animated fadeInLeft">
        <session-info [session]="session" [permissions]="projectPermissions" (afterSave)="reloadSessions()">
        </session-info>

        <container-applications [container]="session" appType="form" (afterChange)="loadContainer()">
        </container-applications>

        <info-edit *ngIf="permissions.viewContainerMetadata" [container]="session" [info]="session?.info"
          [writable]="permissions.editContainerMetadata" (afterSave)="session.info = $event" class="restricted-height">
        </info-edit>

        <container-attachments *ngIf="permissions.viewFileMetadata" [container]="session"
          (afterChange)="loadContainer()">
        </container-attachments>

        <fw-tags *ngIf="permissions.viewTags" [container]="session" (afterSave)="session.tags = $event">
        </fw-tags>

        <container-notes *ngIf="permissions.viewNotes" [container]="session" [notes]="session?.notes"
          (afterSave)="session.notes = $event">
        </container-notes>

        <fw-save-bar></fw-save-bar>
      </div>
    </ng-template>
  </mat-tab>

  <!-- Subject -->
  <mat-tab [attr.tab-id]="'subject'" [label]="'sessionDetail.tabs.subject' | translate">
    <ng-template matTabContent>
      <div class="tab-content animated fadeInLeft">

        <subject-info [subject]="subject" [permissions]="projectPermissions" (afterSave)="loadContainer()"
          style="margin-bottom: 20px;">
        </subject-info>

        <container-applications [container]="subject" appType="form" (afterChange)="loadContainer()">
        </container-applications>

        <info-edit *ngIf="permissions.viewContainerMetadata" [container]="subject" [info]="subject?.info"
          [writable]="permissions.editContainerMetadata" (afterSave)="subject.info = $event" class="restricted-height">
        </info-edit>

        <container-attachments *ngIf="permissions.viewFileMetadata" [container]="subject"
          (afterChange)="loadContainer()">
        </container-attachments>

        <fw-tags *ngIf="permissions.viewTags" [container]="subject" (afterSave)="subject.tags = $event">
        </fw-tags>

        <container-notes *ngIf="permissions.viewNotes" [container]="subject" [notes]="subject?.notes"
          (afterSave)="subject.notes = $event">
        </container-notes>

        <fw-save-bar></fw-save-bar>
      </div>
    </ng-template>
  </mat-tab>

  <!-- Sessions -->
  <mat-tab [attr.tab-id]="'sessions'" *ngIf="containerType === 'subject'"
    [label]="'sessionDetail.tabs.sessions' | translate">
    <ng-template matTabContent>
      <subject-sessions [subject]="subject" class="tab-content"></subject-sessions>
    </ng-template>
  </mat-tab>

  <!-- Project -->
  <mat-tab [attr.tab-id]="'project'" [label]="'sessionDetail.tabs.project' | translate">
    <ng-template matTabContent>
      <div *ngIf="project; else loadingState" class="tab-content animated fadeInLeft">
        <project-info [container]="container" [project]="project" [projectStats]="projectStats" [group]="group"
          [permissions]="projectPermissions" (afterSave)="loadContainer()" style="margin-bottom: 20px;">
        </project-info>

        <container-applications [container]="subject" appType="form" (afterChange)="loadContainer()">
        </container-applications>

        <info-edit *ngIf="permissions.viewContainerMetadata" [container]="project" [info]="project?.info"
          [writable]="permissions.editContainerMetadata"
          (afterSave)="project.info = $event; projectsService.reloadProject$.next()" class="restricted-height">
        </info-edit>

        <container-attachments *ngIf="permissions.viewFileMetadata" [container]="project"
          (afterChange)="loadProject(); projectsService.reloadProject$.next()">
        </container-attachments>

        <fw-tags *ngIf="permissions.viewTags" [container]="project"
          (afterSave)="project.tags = $event; projectsService.reloadProject$.next()">
        </fw-tags>

        <container-notes *ngIf="permissions.viewNotes" [container]="project" [notes]="project?.notes"
          (afterSave)="project.notes = $event; projectsService.reloadProject$.next()">
        </container-notes>

        <fw-save-bar></fw-save-bar>
      </div>
    </ng-template>
  </mat-tab>

  <!-- Collection -->
  <mat-tab [attr.tab-id]="'collection'" *ngIf="collectionId$.value"
    [label]="'sessionDetail.tabs.collection' | translate">
    <ng-template matTabContent>
      <div class="tab-content animated fadeInLeft">
        <div *ngIf="collection" class="card">
          <div class="card-header compact">
            <h1 class="ellipsis">{{ collection.label || ('sessionDetail.collection.noLabel' | translate) }}</h1>
          </div>
          <div style="margin: -15px -20px -18px;">
            <div class="info-row">
              <span class="field-tooltip"></span>
              <span class="field-label">{{ 'sessionDetail.collection.description' | translate }}</span>
              <div class="field-value" style="flex: 2;">
                <span>{{ $any(collection).description }}</span>
              </div>
            </div>
            <div class="info-row">
              <span class="field-tooltip"></span>
              <span class="field-label">{{ 'sessionDetail.collection.curator' | translate }}</span>
              <div class="field-value" style="flex: 2;">
                <span>{{ collection.curator }}</span>
              </div>
            </div>
            <div class="info-row">
              <span class="field-tooltip"></span>
              <a mat-flat-button [href]="collectionHref" color="primary">
                {{ 'sessionDetail.collection.viewCollection' | translate }}
              </a>
            </div>
          </div>
        </div>
        <container-attachments *ngIf="collectionRoleMatrix?.ro" [container]="collection"
          (afterChange)="loadCollection()"></container-attachments>
        <container-notes *ngIf="collectionRoleMatrix?.ro" [container]="collection" [notes]="collection?.notes"
          (afterSave)="collection.notes = $event"></container-notes>
      </div>
    </ng-template>
  </mat-tab>

  <!-- Analyses -->
  <mat-tab [attr.tab-id]="'analyses'" *ngIf="permissions.viewAnalyses"
    [label]="'sessionDetail.tabs.analyses' | translate">
    <ng-template matTabContent>
      <analysis-list [container]="container"
        [containerType]="containerType"></analysis-list>
    </ng-template>
  </mat-tab>

  <!-- Provenance -->
  <mat-tab [attr.tab-id]="'provenance'" *ngIf="permissions.viewJobs"
    [label]="'sessionDetail.tabs.provenance' | translate">>
    <ng-template matTabContent>
      <job-provenance [container]="container"></job-provenance>
    </ng-template>
  </mat-tab>
</mat-tab-group>

<ng-template #loadingState>
  <ng-container *ngIf="containerId$.value; else emptyState">
    <div *ngIf="!error; else errorState" class="loading-state">
      <mat-progress-bar mode="buffer"></mat-progress-bar>
    </div>
  </ng-container>
</ng-template>

<ng-template #emptyState>
  <!-- Blank pane -->
</ng-template>

<ng-template #errorState>
  <div class="info-message">
    <div class="fab">
      <mat-icon>error_outline</mat-icon>
    </div>
    <ng-container [ngSwitch]="error.status">
      <p *ngSwitchCase="403">{{ 'sessionDetail.errors.forbidden' | translate | interpolate:containerType }}</p>
      <p *ngSwitchCase="404">
        {{ 'sessionDetail.errors.notfound' | translate | interpolate:((containerType | titlecase) + ' ' + containerId$.value) }}
      </p>
      <ng-container *ngSwitchDefault>
        <p>{{ 'sessionDetail.errors.generic' | translate | interpolate:(containerType | titlecase) }}</p>
        <button mat-flat-button (click)="loadContainer()"
          color="primary">{{ 'sessionDetail.errors.tryAgain' | translate }}</button>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
